import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Progress } from 'reactstrap';
import { endOfDay, startOfDay, subDays } from 'date-fns';
import Setup from '../../components/Setup';
import { VCS_SLUG } from '../../constants/api';
import Layout from '../../containers/Layout';
import { registerWebhook } from '../../model/registerWebhook';
import isRepositoryListEmpty from '../../utils/isRepositoryListEmpty';
import { EmptyRange } from './components/EmptyRange';
import { Controls } from './components/Controls';
import { LoadingMetrics } from './components/LoadingMetrics';
import { MetricsQuery } from './components/MetricsQuery';
import ApiV2ModelContext from '../../contexts/ApiV2ModelContext';
import * as types from '../../constants/ActionTypes';
export class VelocityReportPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false,
            activeRepositoriesIds: null,
            from: startOfDay(subDays(new Date(), 29)),
            to: endOfDay(new Date()),
        };
        this.repositoryLoader = () => {
            const { repositories } = this.props;
            if (isRepositoryListEmpty(repositories)) {
                this.setState({
                    loading: true,
                }, async () => await this.fetchRepositories(false));
            }
        };
        this.fetchRepositories = async (reload) => {
            const { dispatch } = this.props;
            const repositories = await this.context.getRepositoryList(reload);
            if (repositories.length) {
                dispatch({ type: types.CLEAR_REPOSITORIES });
                dispatch({
                    type: types.BULK_RELOAD_REPOSITORIES,
                    payload: repositories,
                });
                this.setState({
                    loading: false,
                });
            }
        };
        this.handleChangeRepositories = (activeRepositories) => {
            const { activeRepositoriesIds, from, to } = this.state;
            const { history } = this.props;
            this.setState({
                activeRepositoriesIds: activeRepositories.map((item) => item.value).sort(),
            }, () => {
                // @ts-expect-error TS2345: Argument of type 'Location' is not assignable to parameter of type 'string | URL'.
                const url = new URL(location);
                if (from) {
                    // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'string'.
                    url.searchParams.set('from', Math.floor(from.getTime() / 1000));
                }
                if (to) {
                    // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'string'.
                    url.searchParams.set('to', Math.floor(to.getTime() / 1000));
                }
                if (activeRepositoriesIds?.length === 0) {
                    url.searchParams.delete('repositories');
                }
                else {
                    // @ts-expect-error TS2531: Object is possibly 'null'.
                    url.searchParams.set('repositories', this.state.activeRepositoriesIds?.join(','));
                }
                if (history) {
                    // @ts-expect-error TS2345: Argument of type 'Location' is not assignable to parameter of type 'string | URL'.
                    if (new URL(location).search === '') {
                        history.replace(url.toString().replace(url.origin, ''));
                    }
                    else {
                        history.push(url.toString().replace(url.origin, ''));
                    }
                }
            });
        };
        this.handleChangeDateRange = (newDates) => {
            const { history } = this.props;
            const { activeRepositoriesIds } = this.state;
            this.setState(newDates, () => {
                // @ts-expect-error TS2345: Argument of type 'Location' is not assignable to parameter of type 'string | URL'.
                const url = new URL(location);
                // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'string'.
                url.searchParams.set('from', Math.floor(newDates.from.getTime() / 1000));
                // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'string'.
                url.searchParams.set('to', Math.floor(newDates.to.getTime() / 1000));
                if (activeRepositoriesIds) {
                    url.searchParams.set('repositories', activeRepositoriesIds.join(','));
                }
                if (history) {
                    history.push(url.toString().replace(url.origin, ''));
                }
            });
        };
        this.handleRegisterRepo = (repository) => {
            const { dispatch, user } = this.props;
            // @ts-expect-error S2345: Argument of type 'Function' is not assignable to parameter of type
            return registerWebhook(user, repository, dispatch, this.context);
        };
    }
    UNSAFE_componentWillReceiveProps( /*props: Props*/) {
        const { repositories, user } = this.props;
        const { activeRepositoriesIds } = this.state;
        if (!user.user || isRepositoryListEmpty(repositories)) {
            return;
        }
        // @ts-expect-error TS2345: Argument of type 'Location' is not assignable to parameter of type 'string | URL'.
        const url = new URL(location);
        const repos = repositories.list[VCS_SLUG[user.user.vcs]] || {};
        const repoIds = Object.keys(repos).map((slug) => repos[slug].id);
        // @ts-expect-error TS2531: Object is possibly 'null'.
        const fromDate = new Date(url.searchParams.get('from') * 1000);
        // @ts-expect-error TS2345: Argument of type 'Date' is not assignable to parameter of type 'number'.
        const from = url.searchParams.get('from') && !isNaN(fromDate) ? startOfDay(fromDate) : null;
        // @ts-expect-error TS2531: Object is possibly 'null'.
        const toDate = new Date(url.searchParams.get('to') * 1000);
        // @ts-expect-error TS2345: Argument of type 'Date' is not assignable to parameter of type 'number'.
        const to = url.searchParams.get('to') && !isNaN(toDate) ? endOfDay(toDate) : null;
        const activeRepositoriesArray = (url.searchParams.get('repositories') || '').split(',');
        const activeRepositories = activeRepositoriesArray.length >= 1 && activeRepositoriesArray[0]
            ? activeRepositoriesArray.map((id) => parseInt(id))
            : null;
        this.setState((state) => ({
            activeRepositoriesIds: activeRepositories
                ? activeRepositories.filter((id) => repoIds.includes(id))
                : state.activeRepositoriesIds,
            from: from ?? state.from,
            to: to ?? state.to,
        }), () => {
            if ((activeRepositoriesIds || []).length !== (activeRepositories || []).length) {
                // @ts-expect-error TS2531: Object is possibly 'null'.
                this.handleChangeRepositories((this.state.activeRepositoriesIds.map((id) => ({ value: id }))));
            }
        });
    }
    componentDidMount() {
        this.repositoryLoader();
    }
    renderMain() {
        const { repositories, t, user } = this.props;
        const { activeRepositoriesIds, from, to } = this.state;
        const repos = repositories.list[VCS_SLUG[user.user.vcs]] || {};
        const reposSlugsWithHooks = Object.keys(repos); //.filter(slug => repos[slug].active);
        const repositoriesList = reposSlugsWithHooks
            .sort((first, second) => first.localeCompare(second))
            .map((slug) => ({
            value: repos[slug].id,
            label: repos[slug].fullname,
            registered: repos[slug].active,
            registerable: repos[slug].admins?.length > 0 && !repos[slug].webhookLoading,
        }));
        // the first time you open the page we want to have selected everything
        if (activeRepositoriesIds === null && repositoriesList.length > 0) {
            // @todo: bad practice, state shouldn't be changed in render method!
            const filterRepos = repositoriesList.filter((repo) => repo.registered);
            return this.handleChangeRepositories(filterRepos.length === 0 ? repositoriesList : filterRepos);
        }
        if (activeRepositoriesIds === null) {
            return null;
        }
        const repositoriesSlugs = Object.assign({}, ...reposSlugsWithHooks.map((slug) => ({ [repos[slug].id]: slug })));
        const atLeastOneRepoSelected = !!this.state.activeRepositoriesIds?.length;
        return (_jsxs(_Fragment, { children: [_jsx(Controls, { repositoriesList: repositoriesList, activeRepositoriesIds: activeRepositoriesIds, repos: repos, repositoriesSlugs: repositoriesSlugs, from: from, to: to, handleChangeRepositories: this.handleChangeRepositories, handleChangeDateRange: this.handleChangeDateRange }), user.user?.fetchedRepositoriesProgress === null ||
                    user.user?.fetchedRepositoriesProgress >= 1 ? null : (_jsx(Progress, { animated: true, value: 100 * user.user?.fetchedRepositoriesProgress, children: t('fetchingRepositories', { vcs: t(VCS_SLUG[user.user.vcs]) }) })), user.user.fetchedPullRequestsProgress === null || user.user.fetchedPullRequestsProgress >= 1 ? null : (_jsx(Progress, { animated: true, value: 100 * user.user.fetchedPullRequestsProgress, children: t('fetchingPullRequests', { vcs: t(VCS_SLUG[user.user.vcs]) }) })), atLeastOneRepoSelected ? _jsx(MetricsQuery, { repositories: repositories, timezoneId: user.user.timezoneId, activeRepositoriesIds: activeRepositoriesIds, from: from, to: to, pollInterval: user.user.isLoadingPrOrRepositories ? 3000 : 0, user: user, handleRegisterRepo: this.handleRegisterRepo }) : _jsx(EmptyRange, {})] }));
    }
    render() {
        const { match, t, user } = this.props;
        const { loading } = this.state;
        return (_jsxs(Layout, { title: t('velocityReport'), loginRequired: true, match: match, titlePrimary: t('velocityReport'), children: [_jsx("div", { className: "container pb-4", children: loading || !user.user ? _jsx(LoadingMetrics, { controls: true }) : this.renderMain() }), !user.user?.skipTaskOrganisationInvite && _jsx(Setup, { loading: loading })] }));
    }
}
VelocityReportPage.contextType = ApiV2ModelContext;
const mapStateToProps = (state) => ({
    repositories: state.repositories,
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VelocityReportPage));
